import { render } from "./history.vue?vue&type=template&id=44cb4249&scoped=true&ts=true"
import script from "./history.vue?vue&type=script&lang=ts"
export * from "./history.vue?vue&type=script&lang=ts"

import "./history.vue?vue&type=style&index=0&id=44cb4249&lang=scss&scoped=true"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cb4249"]])

export default __exports__